// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hqyjiuoavgrfghwqhkih.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhxeWppdW9hdmdyZmdod3Foa2loIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk4MTU0ODksImV4cCI6MjA1NTM5MTQ4OX0.v33YYfEE1qo1DCQIbYZEvw5OOi2AUEwsDrXrA2LMPfM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});